<template>
  <a-card :bordered="false" title="交易数据" :headStyle="{fontSize:'18px'}">
    <div><span class="side">实时交易数据 </span>{{ now }}</div>
    <a-row class="row-style">
      <a-col :span="5">
        <div class="head-info"><span>支付订单数</span>
          <p>{{ orderData.payOrderCount }}</p></div>
      </a-col>
      <a-col :span="5">
        <div class="head-info"><span>支付用户数</span>
          <p>{{ orderData.payUserCount }}</p></div>
      </a-col>
      <a-col :span="5">
        <div class="head-info"><span>支付金额（元）</span>
          <p><span>￥</span>{{ orderData.payTotalAmount }}</p></div>
      </a-col>
      <a-col :span="5">
        <div class="head-info"><span>支付转化率</span>
          <p>{{ orderData.payRatio }}<span>%</span></p></div>
      </a-col>
      <a-col :span="4">
        <div class="head-info"><span>客单均价（元）</span>
          <p>{{ orderData.customerAveragePrice }}</p></div>
      </a-col>
    </a-row>
    <a-row>
      <div class="line-title">支付金额</div>
      <div id="v-container" v-if='showChart'>
        <v-chart :forceFit="true" :height="500" :data="toyesData" :padding="padding">
          <v-legend :position="positionLine"/>
          <v-tooltip crosshairs="y"></v-tooltip>
          <v-axis></v-axis>
          <v-line position="date*value" color="type"></v-line>
        </v-chart>
      </div>
    </a-row>
    <div>
      <span class="side">交易总览数据</span>
      <span class="right-title">
        <a-button :class="{ isActive1:isChange1 === 1}" style="border:0;" @click="getAllDays(1)">昨日</a-button>
        <a-button :class="{ isActive1:isChange1 === 7}" style="border:0;" @click="getAllDays(7)">近7天</a-button>
        <a-button :class="{ isActive1:isChange1 === 30}" style="border:0;" @click="getAllDays(30)">近30天</a-button>
      <span>
        <a-range-picker
          :disabledDate="disabledDate"
          :placeholder="['开始时间', '结束时间']"
          format="YYYY-MM-DD"
          :value="value"
          style="margin-right:12px;"
          :mode="mode"
          @calendarChange="handlePanelChange"
          @change="handleChange"
          @openChange="openChange"
        />
      </span>

    </span>
    </div>
    <a-row class="row-style">
      <a-col :span="5">
        <div class="head-info"><span>支付订单数</span>
          <p>{{ allData.payOrderCount }}</p></div>
      </a-col>
      <a-col :span="5">
        <div class="head-info"><span>支付用户数</span>
          <p>{{ allData.payUserCount }}</p></div>
      </a-col>
      <a-col :span="5">
        <div class="head-info"><span>支付金额（元）</span>
          <p><span>￥</span>{{ allData.payTotalAmount }}</p></div>
      </a-col>
      <a-col :span="5">
        <div class="head-info"><span>支付转化率</span>
          <p>{{ allData.payRatio }}<span>%</span></p></div>
      </a-col>
      <a-col :span="4">
        <div class="head-info"><span>客单均价（元）</span>
          <p><span>￥</span>{{ allData.customerAveragePrice }}</p></div>
      </a-col>
    </a-row>
    <a-row>
      <div class="line-title">{{ titleHeader }}交易订单数</div>
      <div id="v-container" v-if='showChart'>
        <v-chart :forceFit="true" :height="500" :data="thirtyData" :padding="padding">
          <v-legend :position="positionLine"/>
          <v-tooltip crosshairs="y"></v-tooltip>
          <v-axis></v-axis>
          <v-line position="date*value" color="type"></v-line>
        </v-chart>
      </div>
    </a-row>
    <div>
      <span class="side">销售额类目占比及排名数据</span>
      <span class="right-title">
      <a-button :class="{ isActive2:isChange2 === 1}" style="border:0;" @click="getDays(1)">昨日</a-button>
      <a-button :class="{ isActive2:isChange2 === 7}" style="border:0;" @click="getDays(7)">近7天</a-button>
      <a-button :class="{ isActive2:isChange2 === 30}" style="border:0;" @click="getDays(30)">近30天</a-button>
      <span>
        <a-range-picker
          :disabledDate="disabledDateTime"
          :placeholder="['开始时间', '结束时间']"
          format="YYYY-MM-DD"
          :value="valueTime"
          style="margin-right:12px;"
          :mode="modeTime"
          @calendarChange="handlePanelChangeTime"
          @change="handleChangeTime"
          @openChange="openChangeTime"
        />
      </span>
    </span>
    </div>
    <a-row style="margin-top:30px;min-height:546px;">
      <a-col :span="16">
        <div>
          <a-radio-group @change="onChange" :defaultValue="0">
            <a-radio-button v-for="item in rangeTypeList" :key="item.id" :value="item.id">{{ item.name }}
            </a-radio-button>
          </a-radio-group>
        </div>
        <div v-if="pieData.length == 0" style="text-align:center;margin-top:173px;">
          <a-list :dataSource="[]"/>
        </div>
        <div v-else>
          <v-chart style="width: calc(100% - 10px);" :height="405" :width="240" :padding="5" :data="pieData"
                   :scale="pieScale">
            <v-legend
              :useHtml="true"
              :position="position"
              :reactive="true"
              :offsetX="10"
              :containerTpl="containerTplLegend"
              :itemTpl="itemTplLegend"
              dataKey="ratioCatalogIdName"
            ></v-legend>
            <v-guide
              type="html"
              :position="['50%','50%']"
              :html="guideHtml"
              :zIndex="2"
              :v-style="{
              fontSize: 16,
              textAlign: 'center',
              opacity: 0.75,}"/>
            <v-pie position="percent" color="ratioCatalogIdName"/>
            <v-coord type="theta" :radius="0.8" :innerRadius="0.8"/>
          </v-chart>
        </div>
      </a-col>
      <a-col :span="8">
        <rank-list class="ranking-list-item" title="分销销售额排名" :list="staffSalesData"/>
      </a-col>
    </a-row>
  </a-card>
</template>

<script>
import HeadInfo from '@/components/tools/HeadInfo'
import { RankList } from '@/components'
import moment from 'moment'

const pieScale = [{
  dataKey: 'percent',
  min: 0,
  formatter: '.0%'
}]
export default {
  name: 'TransactionData',
  components: {
    HeadInfo,
    RankList
  },
  data() {
    return {
      titleHeader: '昨日',
      isChange1: 1,
      isChange2: 1,
      channelRadio: 0,
      orderData: {
        payOrderCount: 0,
        payUserCount: 0,
        payTotalAmount: 0,
        payRatio: 0,
        customerAveragePrice: 0
      },
      allData: {
        payOrderCount: 0,
        payUserCount: 0,
        payTotalAmount: 0,
        payRatio: 0,
        customerAveragePrice: 0
      },
      toyesData: [],
      thirtyData: [],
      staffSalesData: [],
      totalAmount: '',
      now: '',
      startTime: '',
      endTime: '',
      allStartTime: '',
      allEndTime: '',
      showChart: false,
      padding: [30, 20, 80, 50],
      position: 'right-center',
      positionLine: 'top-right',
      rangeTypeList: [
        { name: '全部渠道', id: 0 },
        { name: '平台', id: 1 },
        { name: '云仓', id: 2 }
      ],
      pieScale,
      pieData: [],
      containerTplLegend: `<div class="g2-legend"> <table class="g2-legend-list"></table> </div>`,
      mode: ['date', 'date'],
      value: [],
      modeTime: ['date', 'date'],
      valueTime: [],
      startValue: '',
      startTimeValue: ''
    }
  },
  mounted() {
    this.$nextTick(() => {
      this.showChart = true
      this.today()
      this.getAllDays(1)
      this.getRealPayData()
      this.getTodayYesterdayData()
      this.getDays(1)
    })
  },
  methods: {
    moment,
    handleChange(value) {
      this.value = value
    },
    handlePanelChange(value) {
      this.startValue = value[0]._d
      if (value[0] && value[1]) {
        this.allStartTime = moment(value[0]._d).format('YYYY-MM-DD')
        this.allEndTime = moment(value[1] ? value[1]._d : null).format('YYYY-MM-DD')
        this.isChange1 = -1
        this.titleHeader = ''
        this.getAllData()
        this.getThirtyData()
        this.getLogUtils().logWithTag(this.start_at) //2020-01-01
        this.getLogUtils().logWithTag(this.end_at)
      }
    },
    //上方日期框禁用开始日期前后31天
    disabledDate(current) {
      let days = moment().endOf('day').valueOf()
      if (current.valueOf() > days - 3600000 * 24) {
        return true
      }
      return current._d.getTime() > new Date(this.startValue).getTime() + 8.64e7 * 31 || current._d.getTime() < new Date(this.startValue).getTime() - 8.64e7 * 31
    },
    //上方日期选择框关闭回调
    openChange(open) {
      if (!open) {
        this.startValue = ''
      }
    },
    handleChangeTime(value) {
      this.valueTime = value
    },
    handlePanelChangeTime(value) {
      this.startTimeValue = value[0]._d
      if (value[0] && value[1]) {
        this.startTime = moment(value[0]._d).format('YYYY-MM-DD')
        this.endTime = moment(value[1] ? value[1]._d : null).format('YYYY-MM-DD')
        this.getStaffSales()
        this.getSalesRatioData()
        this.isChange2 = -1
        this.getLogUtils().logWithTag(this.start_at) //2020-01-01
        this.getLogUtils().logWithTag(this.end_at)
      }
    },
    //下面日期选择框禁选31天范围
    disabledDateTime(current) {
      let days = moment().endOf('day').valueOf()
      if (current.valueOf() > days - 3600000 * 24) {
        return true
      }
      return current._d.getTime() > new Date(this.startTimeValue).getTime() + 8.64e7 * 31 || current._d.getTime() < new Date(this.startTimeValue).getTime() - 8.64e7 * 31
    },
    //下面日期选择框禁选31天范围
    openChangeTime(open) {
      if (!open) {
        this.startTimeValue = ''
      }
    },
    //饼图自定义lengend
    itemTplLegend: function itemTpl(value, color, checked, index) {
      const obj = this.pieData[index]

      function per() {
        if (obj.proportion === '***') {
          return '***'
        } else {
          return ((obj.percent * 100).toFixed(2) + '%')
        }
      }

      function mone() {
        if (obj.proportion === '***') {
          return '***'
        } else {
          return obj.ratioAmount
        }
      }

      const percent = per()
      const money = mone()
      checked = checked ? 'checked' : 'unChecked'
      return '<tr class="g2-legend-list-item item-' + index + ' ' + checked + '" style="padding:5px;font-size:14px;width:280px;" data-value="' + value + '" data-color=' + color + ' >' + '<td style="width:90px;"><i class="g2-legend-marker" style="background-color:' + color + ';"></i>' + '<span class="g2-legend-text" style="color: #666">' + value + '</span></td>' + '<td style="width:80px;">' + percent + '</td>' + '<td style="text-align:left;color: #666;">' + '￥' + money + '</td>' + '</tr>'
    },
    //饼图自定义guide
    guideHtml: function guideTpl(value, color, checked, index) {
      const ob = this.pieData[index]
      const sum = this.totalAmount
      return '<div>' + '<div style="text-align:center;color:#aaa;">' + '销售额' + '</div>' + '<div style="font-size:20px;text-align:center;">' + '￥' + sum + '</div>' + '</div>'
    },
    //获取饼图数据
    getSalesRatioData() {
      this.pieData = []
      this.getHttpServices().getOrderService().post('api/v2/salesCategoryRatio/selectListApi', {
        endDate: this.endTime,
        merchantId: this.$store.getters.userInfo.merchantId,
        startDate: this.startTime,
        type: this.channelRadio
      })
        .then(res => {
          res.apiListVos.forEach(v => {
            v.ratioAmount = Number(v.ratioAmount)
          })
          const DataSet = require('@antv/data-set')
          const dv = new DataSet.View().source(res.apiListVos)
          dv.transform({
            type: 'percent',
            field: 'ratioAmount',
            dimension: 'ratioCatalogIdName',
            as: 'percent'
          })
          this.pieData = dv.rows
          this.totalAmount = res.totalAmount
          this.getLogUtils().logWithTag('销售额类目占比', this.pieData)
        }).catch(reason => this.showNetWorkErrorMessage(reason))
    },
    //获取今天数据
    today() {
      var now = moment().subtract('days', 0).format('YYYY-MM-DD HH:mm:ss ')
      var date = moment(new Date()).format('YYYY-MM-DD')
      var today = moment().subtract('days', 0).format('YYYY-MM-DD')
      this.now = now
      this.start_at = date
      this.end_at = today
    },
    //获取上方昨日、近7天、近30天日期
    getDays(value) {
      var endTime = moment(new Date().getTime() - 3600 * 24 * 1000).format('YYYY-MM-DD')
      var startTime = moment().subtract('days', value).format('YYYY-MM-DD')
      this.startTime = startTime
      this.endTime = endTime
      this.valueTime = null
      // if (value !== 1){
      //   this.isChange2 = 2
      // }
      this.isChange2 = value
      this.getStaffSales()
      this.getSalesRatioData()
    },
    //获取下方昨日、近7天、近30天日期
    getAllDays(value) {
      var endTime = moment(new Date().getTime() - 3600 * 24 * 1000).format('YYYY-MM-DD')
      var startTime = moment().subtract('days', value).format('YYYY-MM-DD')
      this.allStartTime = startTime
      this.allEndTime = endTime
      this.value = null
      if (value == 30) {
        this.titleHeader = '近30天'
        this.isChange1 = value
      } else if (value == 7) {
        this.titleHeader = '近七天'
        this.isChange1 = value
      } else {
        this.titleHeader = '昨日'
        this.isChange1 = value
      }
      this.getAllData()
      this.getThirtyData()
    },
    //获取实时数据
    getRealPayData() {
      this.getHttpServices().getOrderService().post('order/v2/OrderStatistic/getOrderStatistic', {
        endTime: this.end_at,
        startTime: this.start_at
      }).then(res => {
        this.orderData = res
      }).catch(reason => this.showNetWorkErrorMessage(reason))
    },
    //获取当天交易数据折线图
    getTodayYesterdayData() {
      this.getHttpServices().getOrderService().post('order/v2/OrderStatistic/getPayAmountLineImg', {
        endTime: this.end_at,
        startTime: this.start_at
      }).then(res => {
        this.toyesData = res
      }).catch(reason => this.showNetWorkErrorMessage(reason))
    },
    //获取总览数据
    getAllData() {
      this.getHttpServices().getOrderService().post('order/v2/OrderStatistic/getOrderStatistic', {
        endTime: this.allEndTime,
        startTime: this.allStartTime
      }).then(res => {
        this.allData = res
      }).catch(reason => this.showNetWorkErrorMessage(reason))
    },
    //获取总览折线图数据
    getThirtyData() {
      this.getHttpServices().getOrderService().post('order/v2/OrderStatistic/getPayOrderLineImg', {
        endTime: this.allEndTime,
        startTime: this.allStartTime
      }).then(res => {
        this.thirtyData = res
      }).catch(reason => this.showNetWorkErrorMessage(reason))
    },
    //获取销售额排行榜数据
    getStaffSales() {
      this.getHttpServices().getOrderService().post('order/v2/OrderStatistic/getStaffSalesRank', {
        endTime: this.endTime,
        pageSize: 10,
        startTime: this.startTime
      }).then(res => {
        this.staffSalesDataLength = res.length
        this.staffSalesData = res
      }).catch(reason => this.showNetWorkErrorMessage(reason))
    },
    onChange(e) {
      this.channelRadio = e.target.value
      this.getSalesRatioData()
      this.getLogUtils().logWithTag('渠道选择', this.channelRadio)
    }
  }
}
</script>

<style lang="less">
.isActive1 {
  color: #40a9ff;
}

.isActive2 {
  color: #40a9ff;
}

.side {
  padding-left: 10px;
  line-height: 18px;
  font-size: 16px;
  border-left: 1px solid cornflowerblue;
}

.row-style {
  padding: 20px;
  border-radius: 3px;
  margin: 15px 0;
  border: 1px solid #d5d5d5;
}

.line-title {
  margin: 20px 0 20px 10px;
  font-size: 14px;;
}

.right-title {
  position: absolute;
  right: 20px;
}

.head-info {
  position: relative;
  text-align: left;
  padding: 0 32px 0 0;
  min-width: 125px;

  span {
    color: rgba(0, 0, 0, .45);
    display: inline-block;
    font-size: 14px;
    line-height: 22px;
    margin-bottom: 4px;
  }

  p {
    color: rgba(0, 0, 0, .85);
    font-size: 24px;
    line-height: 32px;
    margin: 0;
  }
}
</style>
